import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export type AddAdminDTO = {
  email: string;
  img_url: string;
  firstName: string;
  lastName: string;
  password: string;
};

type AdminResponse = AddAdminDTO & ApiError;

export const CreateAdmin = (data: AddAdminDTO): Promise<AdminResponse> => {
  return axios
    .post("/admin/create", data)
    .then((response) => response.data as AdminResponse);
};
